import React from 'react'
import './Input.css'

export default function Input(props) {
    return (    
        <div className='inputContainer' style={props.containerStyles}>
            <p className='inputTitle' style={props.titleStyles}>{props.title}</p>
            <input className='inputBody' value={props.value} minLength={props.minLength} onChange={props.onChange} style={props.inputStyles} type={props.type} required={props.required} autoComplete={props.autocomplete} name={props.name} />    
            <span className="error">{props.formSubmitted && props.errors}</span>
        </div>
    )
}